import { combineReducers } from 'redux';

import {
  ACTION_ADD_LOSSES_AND_COMPENSATIONS,
} from '../actionTypes';


const byId = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_LOSSES_AND_COMPENSATIONS:
      return { ...state, ...action.payload.lossesAndCompensations };

    default:
      return state;
  }
};

export default combineReducers({
  byId,
});
